<template>
    <div>
        <v-card flat class="compact-formComplete">
        <v-container style="text-align: center">
          <v-icon size="100" color="light-green">mdi-checkbox-marked-circle</v-icon>
        </v-container>
        <v-container style="text-align: center">
          <h2
          style="color: grey"
          >
            Payment Successful
          </h2>
          <h3
          pt-3
            :style="{
              color: $store.state.currentOrg.orderSecondaryColour
                ? $store.state.currentOrg.orderSecondaryColour
                : $store.state.currentOrg.secondaryColour,
            }"
          >
            Thank you for submitting your order, we have received your payment and will be in touch to make further arrangements.
          </h3>
          <br />

        </v-container>
      </v-card>
      
    </div>
</template>
<script>
export default {
}
</script>